import { parseISO, isBefore, isAfter, startOfDay, endOfDay } from 'date-fns';

/** Inclusive DOS range filter; missing date passes when a range is set. */
export const isInRange = (
    dateStr: string | undefined,
    from: Date | null,
    to: Date | null,
): boolean => {
    if (!from && !to) return true;
    if (!dateStr) return true;
    const d = parseISO(dateStr);
    if (from && isBefore(d, startOfDay(from))) return false;
    if (to && isAfter(d, endOfDay(to))) return false;
    return true;
};

/**
 * Map CMS-1500 f21*DiagnosisCode fields to pointer letter keys (lowercase).
 * Lookups should use `map[pointer.toLowerCase()]`.
 */
export const extractDiagnosisCodes = (obj: object): Record<string, string> => {
    return Object.entries(obj)
        .filter(([key, value]) => key.includes('DiagnosisCode') && value !== null && value !== undefined)
        .reduce(
            (acc, [key, value]) => {
                const match = key.match(/^f21([a-zA-Z])DiagnosisCode$/);
                if (match) {
                    acc[match[1].toLowerCase()] = String(value);
                }
                return acc;
            },
            {} as Record<string, string>,
        );
};
